import { cn } from "@utils/tailwind.util";
import { RelatedWebpage, SuggestionItem } from "@app-types/related-items.type";
import { TagLabel } from "@ui/Content";
import { Pill } from "@ui/Pill";

type ISuggestionWebProps = SuggestionItem<RelatedWebpage>;

export const SuggestionWeb = ({
  item,
  className,
  border,
  variant = "default",
  inline: _inline,
  ...rest
}: ISuggestionWebProps) => {
  return (
    <Pill
      as="a"
      href={item.url}
      target="_blank"
      className={cn(
        "h-9 w-full min-w-0 cursor-pointer items-center align-middle no-underline",
        { "h-7": variant === "small" },
        className
      )}
      border={border}
      {...rest}
    >
      <div className="text-overflow-ellipsis flex items-center gap-2 text-sm font-medium text-content-primary">
        <img src={item.favicon} alt="favicon" className="h-5 w-5 object-cover" />

        <TagLabel>{item.title}</TagLabel>
      </div>
    </Pill>
  );
};
